import React from 'react';
import Skeleton from 'src/components/Skeleton/Skeleton';
import Row from 'src/components/Row';
import Col from 'src/components/Col';

const TAG_SKELETON_COUNT: number = 3;

const ServiceRequestDetailsSkeleton = () => (
  <div className="serviceRequestDetails" aria-hidden>
    <div className="diagnosis-wrapper">
      <table className="diagnosis-table">
        <thead>
          <tr>
            <th className="diagnosis-header-cell">Asset</th>
            <th className="diagnosis-header-cell">Location</th>
            <th className="diagnosis-header-cell">Issue Type</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="diagnosis-data-cell">
              <div className="diagnosis-cell-label">
                <Skeleton variant="text" width="9rem" />
              </div>
            </td>
            <td className="diagnosis-data-cell">
              <div className="diagnosis-cell-label">
                <Skeleton variant="text" width="7rem" />
              </div>
            </td>
            <td className="diagnosis-data-cell">
              <div className="diagnosis-cell-label">
                <Skeleton variant="text" width="8rem" />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <Row>
      <Col xs={12}>
        <span className="serviceRequestDetails__label">Description</span>
        <div style={{ marginBottom: '0.4rem' }}>
          <Skeleton variant="text" width="95%" />
        </div>
        <div style={{ marginBottom: '0.4rem' }}>
          <Skeleton variant="text" width="80%" />
        </div>
        <Skeleton variant="text" width="60%" />
      </Col>
    </Row>

    <Row>
      <Col xs={6}>
        <span className="serviceRequestDetails__label">Item ID</span>
        <Skeleton variant="text" width="14rem" />
      </Col>
    </Row>

    <br />

    <Row>
      <Col xs={12}>
        <strong>Tags: </strong>
        <span style={{ display: 'inline-flex', gap: '0.6rem', verticalAlign: 'middle' }}>
          {Array.from({ length: TAG_SKELETON_COUNT }, (_, index: number) => (
            <Skeleton
              key={`sr-details-tag-skeleton-${index}`}
              variant="text"
              width="5rem"
            />
          ))}
        </span>
      </Col>
    </Row>

    <br />
  </div>
);

export default ServiceRequestDetailsSkeleton;
